import { fromJS } from 'immutable';
import { CHECK_PUSH, SET_PUSH_STATUS, TURN_OFF_PUSH, TURN_ON_PUSH } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  /** Null until checked; then a pushStatus answer or 'server-off'. */
  status: null,
  busy: false,
  error: null,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case CHECK_PUSH:
    case TURN_ON_PUSH:
    case TURN_OFF_PUSH:
      return state.set('busy', true).set('error', null);

    case SET_PUSH_STATUS:
      return state.merge(action.payload).set('busy', false);

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
